export function optimisticTutorialProgress(progress, command) {
  const current = progress || { status: "not_started", currentStep: "first_sale", version: 0 };
  if (command.action === "start" || command.action === "restart") {
    return { ...current, status: "in_progress", currentStep: "first_sale" };
  }
  if (command.action === "complete") return { ...current, status: "completed" };
  if (command.action === "skip") return { ...current, status: "skipped" };
  if (command.action !== "advance" || current.status !== "in_progress") return current;
  const next = {
    first_sale: "inventory_update",
    inventory_update: "transaction_history",
    transaction_history: "dashboard_overview",
  }[current.currentStep];
  return next ? { ...current, currentStep: next } : current;
}
